import React, { PropTypes } from "react";
import ReactGA from "react-ga";

import DismissableAlert from "./DismissableAlert";
import "./MainForm.css";

class MainForm extends React.Component {
  constructor(props) {
    super(props);
    this.selectTextField = this.selectTextField.bind(this);
    this.updateHeight = this.updateHeight.bind(this);
    this.updateWeight = this.updateWeight.bind(this);
  }

  selectTextField(event) {
    this.previousValue = event.target.value;
    event.target.value = "";
  }

  updateWeight(event) {
    if (this.weightTimeout) {
      clearTimeout(this.weightTimeout);
      this.weightTimeout = null;
    }
    let value = event.target.value;
    if(event.target.value === ""){
      value = this.previousValue;
    }
    this.props.changeWeight(value);
    this.weightTimeout = setTimeout(this.sendGAWeightEvent, 1000);
  }

  sendGAWeightEvent() {
    ReactGA.event({
      category: "Form View",
      action: "Weight",
      label: "Changed",
    });
  }

  updateHeight(event) {
    if (this.heightTimeout) {
      clearTimeout(this.heightTimeout);
      this.heightTimeout = null;
    }
    let value = event.target.value;
    if(event.target.value === ""){
      value = this.previousValue;
    }
    this.props.changeHeight(value);
    this.heightTimeout = setTimeout(this.sendGAHeightEvent, 1000);
  }

  sendGAHeightEvent() {
    ReactGA.event({
      category: "Form View",
      action: "Height",
      label: "Changed",
    });
  }

  render() {
    return(
      <div className="container main-form">

        <DismissableAlert showAlert={this.props.showAlert} dismissAlert={this.props.dismissAlert}/>

        <div className="row counter-display-container">
          <div>
            <label>
              <input className="height counter-display"
                type="number"
                min="10"
                max="46"
                maxLength="3"
                step="0.5"
                pattern="[0-9.]*"
                value={this.props.height}
                onClick={this.selectTextField}
                onChange={this.updateHeight}
                onBlur={this.updateHeight}
                onKeyUp={this.updateHeight}  />inches</label>
            <label>
              <input className="weight counter-display"
                type="number"
                min="0"
                max="48"
                maxLength="3"
                step="0.5"
                pattern="[0-9.]*"
                value={this.props.weight}
                onClick={this.selectTextField}
                onChange={this.updateWeight}
                onBlur={this.updateWeight}
                onKeyUp={this.updateWeight}  />lbs
            </label>
          </div>
        </div>

        <div className="width-slider-row row">
          <label htmlFor="height">Height (in inches)</label>
          <input className="height-slider"
            type="range"
            min="10"
            max="46"
            value={this.props.height}
            step="0.5"
            onChange={this.updateHeight} />
        </div>

        <div className="width-slider-row row">
          <label htmlFor="weight">Weight (in lbs)</label>
          <input className="weight-slider"
            type="range"
            min="0"
            max="48"
            value={this.props.weight}
            step="0.5"
            onChange={this.updateWeight} />
        </div>
      </div>
    );
  }
}

MainForm.propTypes = {
  changeHeight: PropTypes.func.isRequired,
  changeWeight: PropTypes.func.isRequired,
  showAlert: PropTypes.bool.isRequired,
  dismissAlert: PropTypes.func.isRequired,
  height: PropTypes.number.isRequired,
  weight: PropTypes.number.isRequired,
};

export default MainForm;



/** WEBPACK FOOTER **
 ** ./src/components/MainForm/MainForm.js
 **/